import { TokenService, FilterService, ClaimsService, AppSettingsService } from ".";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable()
export class LogoutService {

    private logoutTimer: any;

    constructor(private router: Router,
        private appSettingsService: AppSettingsService,
        private tokenService: TokenService,
        private filterService: FilterService,
        private claimsService: ClaimsService) {
    }

    public connectionTimeOut() {
        if (this.logoutTimer) {
            alert('Connection timeout!\nYou will be redirected to the login page.');
            this.logout();
        }
    }

    public logout() {
        this.unsubscribeTimer();

        this.tokenService.setRefreshToken(null);
        this.tokenService.setBearerToken(null);
        this.tokenService.setBearerTokenExpiration(null);
        this.filterService.setCountries(null);
        this.filterService.setProviders(null);
        this.filterService.setPublishers(null);
        this.filterService.setPublisherGroups(null);
        this.filterService.setBrands(null);
        this.claimsService.setUserId(0);
        this.claimsService.setUserTypeId(0);
        this.claimsService.setFirstName(null);
        this.claimsService.setLastName(null);

        this.router.navigate([this.appSettingsService.LoginPath]);

        this.removeResidualElements();
    }

    private removeResidualElements() {
        // !!! remove modal background after logout
        if ($('body.modal-open')) {
            $('body.modal-open').removeClass();
            $('div.modal-backdrop').remove();
        }
    }

    public unsubscribeTimer() {
        if (this.logoutTimer) this.logoutTimer.unsubscribe();
    }

    public getTimer() {
        return this.logoutTimer;
    }

    public setTimer(timeout: any) {
        this.logoutTimer = timeout;
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/logout.service.ts